// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ep4m","left":"styles_left__1w70J"};